import styled from 'styled-components';

import { white } from 'ui/theme/colors';

export const Card = styled.div`
  background: ${white};
  padding: 24px;
  border-radius: 8px;
`;
